import React from "react";

const ProductCard = ({ item }) => {
  if (!item) {
    return null;
  }

  const tags = item.tags || [];

  return (
    <div className="c-product-card">
      <div className="c-product-card__articlecount">
        {item.articleCount > 0 ? (
          <a href={item.url + "#parts"}>
            {item.articleCount} {i18n.getString("productFilter.matchingProducts")}
          </a>
        ) : null}
      </div>

      <a href={item.url}>
        <div className="c-product-card__outer">
          <div className="c-product-card__inner">
            {item.imageUrl ? (
              <div className="c-product-card__image">
                <img
                  src={i18n.CdnHostName + item.imageUrl + "?preset=c-product-list&width=220"}
                  width="220"
                  height="220"
                  alt={item.name}
                />
              </div>
            ) : null}

            <h4 className="c-product-card__heading">{item.name}</h4>

            {tags.length > 0 && (
              <p className="c-product-card__tags">
                {tags.map((tag) => (
                  <span key={tag}>{tag}</span>
                ))}
              </p>
            )}

            <p className="c-product-card__paragraph">{item.excerpt}</p>

            <table className="c-product-card__table">
              <tbody>
                {item.formattedDataCollection.map((data) => (
                  <tr className="c-product-card__table-row" key={data.fieldHeader}>
                    <td className="c-product-card__label">{data.fieldHeader}</td>
                    <td className="c-product-card__value">{data.fieldValue.replaceAll("|", ",")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </a>
    </div>
  );
};

export default ProductCard;
